<template>
<div class="row wrapper white-bg page-heading page-title light-bottom-shadow">

  <div class="col-sm-12 page-headingRow">
    <h2>{{ route.meta.name }}</h2>

    <Breadcrumbs />

    <slot name="action-button"></slot>
  </div>

</div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'

export default {
  name: 'PageTitle',
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  components: {
    Breadcrumbs
  }
}
</script>

<style scoped>
.page-headingRow {
  position: relative;
}

h2 {
  font-size: 24px !important;
  font-weight: 100;
  margin: 20px 0 10px 0;
}
</style>
